import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ToastProvider, useToast } from './contexts/ToastContext';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Toast from './components/Toast';
import PageLoader from './components/PageLoader';
import Home from './pages/Home';
import About from './pages/About';
import ProjectPage from './pages/ProjectPage';
import TripSplit from './pages/TripSplit';
import NotFound from './pages/NotFound';

const TRIP_SPLIT_HASH = '#/trip-split';

function useIsTripSplitFromHash() {
  const [hash, setHash] = useState(() => window.location.hash);
  useEffect(() => {
    const onHashChange = () => setHash(window.location.hash);
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);
  return hash === TRIP_SPLIT_HASH;
}

function HomeOrTripSplit() {
  const isTripSplitFromHash = useIsTripSplitFromHash();
  return isTripSplitFromHash ? <TripSplit /> : <Home />;
}

function AppContent() {
  const { toast, hideToast } = useToast();
  const location = useLocation();
  const isTripSplitFromHash = useIsTripSplitFromHash();
  const isTripSplit = location.pathname === '/trip-split' || (location.pathname === '/' && isTripSplitFromHash);

  return (
    <div className="w-full overflow-x-hidden bg-white min-h-screen">
      {!isTripSplit && <Navigation />}
      <Routes>
        <Route path="/" element={<HomeOrTripSplit />} />
        <Route path="/about" element={<About />} />
        <Route path="/trip-split" element={<TripSplit />} />
        <Route path="/:slug" element={<ProjectPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!isTripSplit && <Footer />}
      <Toast message={toast.message} isVisible={toast.isVisible} onClose={hideToast} />
    </div>
  );
}

function App() {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <>
      {!isLoaded && <PageLoader onLoaded={() => setIsLoaded(true)} />}
      <div
        className="transition-opacity duration-300 ease-out"
        style={{ opacity: isLoaded ? 1 : 0 }}
      >
        <Router>
          <ToastProvider>
            <AppContent />
          </ToastProvider>
        </Router>
      </div>
    </>
  );
}

export default App;
